/**
 * 海滨之心入口按键
 */

const RES = [
"packed/SeasideStarIcon.pack",
"font/zzgftongxin_30_purplestroke.png",
"font/zzgftongxin_30_purplestroke.fnt"
]
// [1, "kAnimal", 0],
// [1, "kBlue", 1],
// [1, "kGreen", 2],
// [1, "kOrange", 3],
// [1, "kPurple", 4],
// [1, "kRed", 5],
// [1, "kYellow", 6],
const ANIM_STR = [
    "",
    "hippo1_star",
    "frog1_star",
    "bear1_star",
    "owl1_star",
    "fox1_star",
    "chick1_star"
]

require("clover/scene/component/homescene/HomeSceneButton")

let SeasideStarIcon = xClass("SeasideStarIcon", HomeSceneButton)
// SeasideStarIcon.preloadRes = function(useMask = false) {
//     return preloadWithLoadingPromise(RES, useMask)
// }
SeasideStarIcon.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}

SeasideStarIcon.prototype.ctor = function () {
    let self = this
    // icon_seasidestar
    // HomeSceneButton.prototype.ctor.call(self, getText('海滨之星'), "seasidestar_icon/icon_seasidestar.png", true, true, PromptTypeDef.justDot);  //islands.supstar.icon
    // HomeSceneButton.prototype.ctor.call(self, getText('海滨之星'), "cocos/seasidestar_seasidestar_icon.csb", true, true, PromptTypeDef.justDot);  //islands.supstar.icon
    HomeSceneButton.prototype.ctor.call(self, getText('海滨之星'), "cocos/seaside_star_Icon_new_Icon_star.csb", true, true, PromptTypeDef.justDot);
    self.ssManager = SeasideStarManager.getInstance();

    self.posIndex = 60;
    self.isBusy = false;

    self.imageNode.scale = 1
    
    let progressBg = cc.Sprite.createWithSpriteFrameName("seaside_star_Icon_new/progress2_star.png")
    self.imageNode.addChild(progressBg);
    progressBg.setLocalZOrder(-1)


    // let sp = cc.Sprite.createWithSpriteFrameName("seasidestar_icon/img_seasidestarbar.png")
    let sp = cc.Sprite.createWithSpriteFrameName("seaside_star_Icon_new/progress1_star.png")
    
    let progressTimer = cc.ProgressTimer.create(sp);
    progressTimer.setType(cc.PROGRESS_TIMER_TYPE_RADIAL);
    progressTimer.setAnchorPoint(0.5, 0.5);
    progressTimer.setScale(1);
    progressTimer.setMidpoint(cc.p(0.5, 0.5))
    progressTimer.setPercentage(80)
    // let progressBg = self.imageNode.getChildByName("progressBg") 
    progressBg.addChild(progressTimer);
    progressTimer.setPosition(progressBg.getContentSize().width/2,progressBg.getContentSize().height/2)
    // // progressBg.scale = 0.9
    // progressBg.y = 0
    // progressBg.x = 0
    this.progressTimer = progressTimer
    // self.imageNode.getChildByName("icon").y = 0

    // progressTimer.x = 200
    // self.imageNode.anim = cc.CSLoader.createTimeline("cocos/seaside_star_Icon_new_Icon_star.csb");


    
    // this.imageNode.y = -10
    // this.imageNode.getChildByName("progressBg").scale = 0.9

    self.initUI();

    self._name = "SeasideStarIcon"


    self.node.on(UIButtonEvent.Down, function (evt) {
        cc.log("[Seaside]", "按下");
        self.progressTimer.setVisible(false)
        // self.imageNode.runAction(self.imageNode.anim);
        // self.imageNode.anim.gotoFrameAndPlay(0, false)
    })
    self.node.on(UIButtonEvent.Up, function (evt) {
        cc.log("[Seaside]", "抬起");
        self.progressTimer.setVisible(true)
    })
}
SeasideStarIcon.prototype.initAfter = function () {
    HomeSceneButton.prototype.initAfter.call(this);
    this.textTip.y = this.text.y - this.text.height/2 -10
}

SeasideStarIcon.prototype.initUI = function () {
    this.textTip = cc.LabelTTF.create("(可领取)", FONT_DEF.microsoftYahei_20_orangeStroke)
    this.addChild(this.textTip)

    this.newLabel = cc.Sprite.createWithSpriteFrameName("homeLib/lib_lb_new.png");
    this.addChild(this.newLabel)
    this.refreshUI()


    this.showNode = cc.CSLoader.createNode("cocos/seaside_star_Icon_new_common_qizi.csb")
    let scene = cc.Director.getInstance().getRunningScene()
    scene.addChild(this.showNode)
    let num_label = cc.LabelBMFont.create("123", "font/zzgftongxin_30_purplestroke.fnt")
    this.showNode.getChildByName("bp_9_1").addChild(num_label)
    this.showNode.setLocalZOrder(99999)
    num_label.setName("num_label")
    num_label.scale = 3
    num_label.setPosition(80,50)
    SpriteUtil.findBlendChilds_AddOneOne(this.showNode, false);
    this.showNode.setVisible(false)

}
SeasideStarIcon.prototype.refreshUI = function () {
    let index = this.ssManager.getShowIconIndex()
    let rewardList = this.ssManager.getProgressRewardList();
    let msgCur = rewardList[index]

    let stageMaxNum = msgCur.progress - msgCur.startP
    let stageNum = this.ssManager.getData().collectionNum - msgCur.startP
    stageNum = stageNum > 0 ? stageNum : 0
    cc.log("[Seaside] refreshUI msgCur", msgCur);
    this.progressTimer.setPercentage(100*stageNum/stageMaxNum)

    this.textTip.setVisible(this.ssManager.isHaveRewardCanRecvie())
    if (this.ssManager.isShowNewTip()){
        this.playNewAction()
    }else{
        this.hideNewAction()
    }
    // this.textTip 
    // this.newLabel
}
SeasideStarIcon.prototype.hideNewAction = function () {
    this.newLabel.stopAllActions()
    this.newLabel.setVisible(false)
}
SeasideStarIcon.prototype.playNewAction = function () {
    this.newLabel.setVisible(true)
    this.newLabel.stopAllActions()
    this.newLabel.setPosition(90, 6)
    let offsetx = 90
    let offsety = 0
    this.newLabel.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.MoveTo.create(0.2333, cc.p(17.25 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(17.25 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), cc.MoveTo.create(0.3, cc.p(8.5 + offsetx, offsety + 0)), cc.MoveTo.create(0.2333, cc.p(0 + offsetx, offsety + 0)))))
}

SeasideStarIcon.prototype.tryUpdateIcon = function () {
    let self = this
    this.refreshUI()
}

SeasideStarIcon.prototype.onCick = function () {
    cc.log("[Seaside]", "click home icon...");
    // this.playShowGetAction()
    // this.ssManager.updateIcon(5)
    if (!this.ssManager.isOpen()){
        this.ssManager.updateIcon()
        Toast.make("活动已结束")
        let homeScene = require("clover/scene/HomeScene").getInstance()
        homeScene.updateStartBtnSeasideStar()
        return
    }
    NewUserTaskManager.getInstance().tryCompleteTask(NewUserTaskManager.TASK_TYPE_ENUM.activity)
    DCAssist.dc4OpenModule(ModuleName.COAST_STAR)
    let self = this
    this.ssManager.saveLocalActId()
    this.hideNewAction()
    self.ssManager.showSeasideStarPanel()

    // this.showNode.anim = cc.CSLoader.createTimeline("cocos/seaside_star_Icon_new_common_qizi.csb");
    // this.showNode.runAction(this.showNode.anim);
    // this.showNode.anim.gotoFrameAndPlay(0, true)
    // this.showNode.setPosition(cc.p(display.width/2,display.height/2))

}

SeasideStarIcon.prototype.cleanup = function () {
    let self = this;
    ResManager.release(RES);
    cc.Node.prototype.cleanup.call(self);
}


SeasideStarIcon.prototype.playGetAction = function () {
    cc.log("[Seaside]", "playGetAction ");
    this.imageNode.anim = cc.CSLoader.createTimeline("cocos/seaside_star_Icon_new_Icon_star.csb");

    this.imageNode.runAction(this.imageNode.anim);
    this.imageNode.anim.gotoFrameAndPlay(0, false)
}

SeasideStarIcon.prototype.playShowGetAction = function (num,cb) {

    if (!self.alwaysShow){
        cb && cb()
        return
    }
    let num_label = this.showNode.getChildByName("bp_9_1").getChildByName("num_label")
    num = num ? num : 0
    num_label.string = "+"+num

    this.showNode.setVisible(true)
    let common_key1 = this.showNode.getChildByName("common_key1")
    // common_key1.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame(`StaticItem0${this.ssManager.getCollectColor() }.png`));
    common_key1.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame(`seaside_star_Icon_new/${ANIM_STR[this.ssManager.getCollectColor()]}.png`));
    this.showNode.anim = cc.CSLoader.createTimeline("cocos/seaside_star_Icon_new_common_qizi.csb");
    this.showNode.runAction(this.showNode.anim);
    this.showNode.anim.gotoFrameAndPlay(0, false)
    // this.showNode.setPosition(cc.p(display.width/2,display.height/2))
    let targetPos = this.getParent().convertToWorldSpaceAR(cc.p(0,this.getPositionY() - 100))
    this.showNode.setPosition(cc.p(display.width/2,targetPos.y))

    this.showNode.anim.setLastFrameCallFunc(() => {
        this.showNode.anim.clearLastFrameCallFunc();
        HomeSceneAnimation.playGetKeyAnimation(this,()=>{
            this.playGetAction()
        },()=>{
            if (cb){
                cb()
            }
        },{
            // coinStr:`StaticItem0${this.ssManager.getCollectColor() }.png`
            coinStr:`seaside_star_Icon_new/${ANIM_STR[this.ssManager.getCollectColor()]}.png`
        });
    });
}

module.exports = SeasideStarIcon
